export const DORIE_URL = "https://store.dorie.io/12253780/book";
export const WHATSAPP_URL =
    "https://wa.me/972522647497?text=" +
    encodeURIComponent("مرحباً مياسة، أود الاستفسار عن أحد علاجات ميام.");
export const PHONE_TEL = "tel:+972522647497";
export const PHONE_DISPLAY = "052-264-7497";
export const MAPS_URL =
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("مدرسة الأمل يركا");
export const INSTAGRAM_URL = "https://www.instagram.com/mayasa_molla/";
export const WHATSAPP_CARDS_URL =
    "https://wa.me/972522647497?text=" +
    encodeURIComponent("مرحباً مياسة، أود طلب بطاقات «أي زهرة أنتِ؟».");

export const NAV_LINKS = [
    { id: "home", label: "الرئيسية" },
    { id: "about", label: "عن مياسة" },
    { id: "certificates", label: "الشهادات" },
    { id: "treatments", label: "العلاجات" },
    { id: "packages", label: "الباقات والأسعار" },
    { id: "flower-cards", label: "البطاقات" },
    { id: "contact", label: "تواصل معنا" },
];
